import SchoolLogListSection from "./components/school-log-list-section";

function SchoolLogs() {
  return (
    <div className="h-full flex flex-col gap-6">
      {/* Student Logs List - Takes remaining height */}
      <div className="h-full">
        <SchoolLogListSection />
      </div>
    </div>
  );
}

export default SchoolLogs;
